export default __webpack_public_path__ + "static/media/img334.2d8e3922.png";